import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import {history} from "../../../utils/history";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Constants from "../../../utils/constants";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";
import AllUsersApi from "../../../services/ApiServices/AllUsersApi";
import Translate from "../../../utils/Translate";
import ReactFlagsSelect from "react-flags-select";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class LoginLeumitIDComposed extends Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue) {
            this.props.history.push(appendIchilovQuery('/dashboard'));

        }
        this.recaptchaRef = React.createRef()

        this.state = {
            entry: {Phone_num1: '', ID_passport: ''},
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let {entry} = this.state
        let validationSchema = Yup.object().shape({
            Phone_num1: Yup.string().required(t('defaults.Registration.mandatoryField')),
            ID_passport: Yup.string().required(t('defaults.Registration.mandatoryField')).matches(/^\d+$/, t('defaults.Registration.digitsOnly')).test('len', t('defaults.Registration.nineCharacters'), val => val.length === 9),
        })
        let errors = await validationHelper.validate(entry, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {

            await this.submitData("NOTOKENINLOCAL");
        }

    }

    onValueChange = async (name, value) => {
        let {entry, validationSchema} = this.state

        utils.set(entry, name, value)
        let entryValidator = entry

        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }


    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        await this.initValidation()

        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {entry} = this.state
        let response = await authenticationService.PatientLogin(entry.ID_passport, entry.Phone_num1, reCaptchaToken);


        if (response.status < 400) {
            let data = response.data
            if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === '2fa') {
                const {from} = {from: {pathname: "/pain_patient_2FA"}};
                let data = {Phone_num1: entry.Phone_num1, ID_passport: entry.ID_passport}
                this.props.history.push({
                    pathname: appendIchilovQuery(`/pain_patient_2FA`),
                    state: {
                        data,
                        from: {
                            fromPath: `/pain_patient_login`,
                        }
                    },
                })
            } else {
                this.setState({
                    entry: {Phone_num1: '', ID_passport: ''},
                    isErr: true,
                    errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.idPhoneError'),
                })
            }
        } else {
            this.setState({
                entry: {Phone_num1: '', ID_passport: ''},
                isErr: true,
                errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.connectionError'),
            })
        }
    }

    goBack() {
        this.props.history.push(appendIchilovQuery('/login_pain'))
    }

    gotoPatientReg() {
        this.props.history.push(appendIchilovQuery('/register_pain'))
    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {t} = this.props
        let {entry} = this.state
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-loginID'}>{t('defaults.login.login')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.Registration.ID_passport')}
                                           name={"ID_passport"}
                                           value={entry.ID_passport}
                                           inputMode={"numeric"}
                                           pattern={"[0-9]"}
                                           maxLength={9}
                                           onChange={(event) => this.onValueChange("ID_passport", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'ID_passport') ? "input-pic2" : "input-pic"}
                                        svgname={'idPass'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'ID_passport')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'ID_passport')}/>
                            </div>

                            <div>

                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.Registration.Phone')}
                                           name={"Phone_num1"}
                                           value={entry.Phone_num1}
                                           inputMode={"numeric"}
                                           pattern={"[0-9]"}
                                           onChange={(event) => this.onValueChange("Phone_num1", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Phone_num1') ? "input-pic2" : "input-pic"}
                                        svgname={'smartPhone'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Last_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Last_name')}/>
                            </div>


                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit.bind(this)}>{t('defaults.login.login')}</button>

                            </div>
                            <div className="leumit-login-selection" style={{marginTop: '15px'}}>
                                <div className={'account-exists-block'} onClick={() => this.gotoPatientReg()}>
                                    <SvGraphics svgname={'enter'}
                                                style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                    <div className="account-exists">{t('defaults.login.Register')}</div>
                                </div>
                                <div className={"account-exists-space"}/>
                                <div className={'account-exists-block'} onClick={() => this.goBack()}>
                                    <SvGraphics svgname={'stethoscope'}
                                                style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                    <div className="account-exists"
                                    >{t('defaults.Registration.doctor_signIn')}</div>
                                </div>
                            </div>

                        </div>


                    </div>
                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.Registration.reg_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>

                </div>

                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                {!isLocal && <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>}
            </div>

        )
    }
}

let LoginPainID = compose(
    withTranslation()
)(LoginLeumitIDComposed)
export default LoginPainID;
